export default __webpack_public_path__ + "static/media/shrewdblow2.0053771b.png";